import { TestFromRegistry } from "../../types";

export enum ACTIONS {
  EDIT_TEST,
  TEST,
  MIN_CORRECT_ANSWERS_COUNT,
  OPEN_FORM,
  ADD_QUESTION
}

export interface AddQuestion {
  type: ACTIONS.ADD_QUESTION;
  payload: {
    addQuestion: boolean;
  };
}

export interface OpenForm {
  type: ACTIONS.OPEN_FORM;
  payload: {
    openForm: boolean;
  };
}

export interface EditTest {
  type: ACTIONS.EDIT_TEST;
  payload: {
    editTest: boolean;
  };
}

export interface MinCorrectAnswerCount {
  type: ACTIONS.MIN_CORRECT_ANSWERS_COUNT;
  payload: {
    minCorrectCunt: number;
  };
}

export interface Test {
  type: ACTIONS.TEST;
  payload: {
    test: any;
  };
}

////////////////////////////////////////////////////////////

export const setOpenForm = (open: boolean): OpenForm => {
  return {
    type: ACTIONS.OPEN_FORM,
    payload: {
      openForm: open
    }
  };
};

export const setEditTest = (edit: boolean): EditTest => {
  return {
    type: ACTIONS.EDIT_TEST,
    payload: {
      editTest: edit
    }
  };
};

export const setTest = (test: TestFromRegistry | undefined): Test => {
  return {
    type: ACTIONS.TEST,
    payload: {
      test: test
    }
  };
};

export const setMinCorrectAnswerCount = (count: number): MinCorrectAnswerCount => {
  return {
    type: ACTIONS.MIN_CORRECT_ANSWERS_COUNT,
    payload: {
      minCorrectCunt: count
    }
  };
};

export const setAddQuestion = (addQuestion: boolean): AddQuestion => {
  return {
    type: ACTIONS.ADD_QUESTION,
    payload: {
      addQuestion: addQuestion
    }
  };
};

export type RegisterTestActions = EditTest | Test | MinCorrectAnswerCount | OpenForm | AddQuestion;
